
import idb from './db';
import User from '../model/User';
import BuildInfo from './BuildInfo';
import Crime from '../model/Crime';
import SubjectConfig from './SubjectConfig';


const baseURL = "https://wasiliysoft.ru/smartapk/api_v1/"
const send = (uuid: string, subjectId: string, crime: string): XMLHttpRequest | null => {
    var params = new URLSearchParams();
    params.append('uuid', uuid);
    params.append('subjectId', subjectId);
    params.append('crime', crime);
    params.append('webAppBuild', BuildInfo.build.toString());

    var request = new XMLHttpRequest();
    // request.open('POST', 'https://wasiliysoft.ru/smartapk/api_v1/debug.php', false);
    request.open('POST', baseURL + '/upload.php', false);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
    try {
        request.send(params);
        return request;
    } catch (e) {
        return null;
    }
}

class Result {
    code: number;
    message: string;
    constructor(code: number, message: string) {
        this.code = code;
        this.message = message;
    }
}
export default class {
    /**
     * @param isBackground - если истина то будут выведены только сообщения об успешном обновлении
     */
    static updateSubjectConfig = (isBackground: boolean): Promise<string> => {
        return new Promise<string>(function (resolve, reject) {
            var xhr = new XMLHttpRequest();

            var cfg = SubjectConfig.getLocal();
            var user = new User();
            xhr.open("GET", baseURL + '/config.php?'
                + 'webAppBuild=' + BuildInfo.build
                + '&subjectId=' + user.subjectId.toLowerCase()
                + '&generated=' + cfg.generated, true);

            xhr.onload = function () {
                if (this.status === 200) { // статус ответа сервера
                    let result: Result = JSON.parse(this.responseText);
                    console.log('ConfigUpdater', ' code ', result.code);
                    switch (result.code) {
                        case 200:
                            SubjectConfig.saveLocal(JSON.parse(result.message));
                            console.log('ConfigUpdater', 'Конфигурация обновлена');
                            resolve("Конфигурация обновлена");
                            break;
                        case 204:
                            console.log('ConfigUpdater', 'Обновление не требуется');
                            if (!isBackground) {
                                resolve("Обновление не требуется");
                            } else {
                                resolve("");
                            }
                            break;
                        case 426:
                            console.error('ConfigUpdater', 'Обновите приложение');
                            resolve("Обновите приложение");
                            break;
                        default:
                            console.error('ConfigUpdater', result.message);
                            reject(result.message);
                            break;
                    }
                } else {
                    console.error('server return ' + JSON.stringify(this));
                    reject("Проверьте подключение");
                }
            };
            xhr.onerror = function () {
                console.error('server return ' + JSON.stringify(this));
                reject("Проверьте подключение");
            };
            xhr.send();
        });
    }

    static uploadCrimes = async (): Promise<string> => {
        const user: User = new User();
        const db: idb = new idb();
        const crimes: Crime[] = await db.crimeTable.toArray();
        console.log("crimes.length = " + crimes.length);

        for (let crime of crimes) {
            crime = Object.assign(new Crime(), crime);

            let resp = await send(
                crime.uuid,
                user.subjectId,
                crime.toBase64(user.userId)
            );

            console.log(resp);

            if (resp !== null && resp.status === 200) {
                let result: Result = JSON.parse(resp.responseText);
                if (result.code === 200) {
                    await db.crimeTable.delete(crime.uuid);
                } else {
                    console.error(result.message);
                    return result.message;
                }
            } else {
                console.error(resp);
                return "Ошибка отправки замечаний";
            }
        }
        return 'Замечания отправлены';

    }
};